// 이메일 유효성 체크
export const correctEmail = (email: string) => {
    const regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    return regex.test(email);
};

// 비밀번호 유효성 체크
// 8자 이상, 대문자 포함, 숫자 포함, 특수문자 포함
export const correctPw = (pw: string) => {
    const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}[\];:'",.<>/?\\|`~])[A-Za-z\d!@#$%^&*()_\-+={}[\];:'",.<>/?\\|`~]{8,}$/;
    return regex.test(pw);
};

// 아이디 정규식
export const correctId = (id: string) => {
    const regex = /^[a-zA-Z0-9_.]{1,12}$/;
    return regex.test(id);
};

// 한글, 숫자, 특문 정규식
export const regexKorean = (text: string) => {
    const regex = /^[^A-Za-z]*$/;
    return regex.test(text);
};

// 영문, 숫자, 특문 정규식
export const regexEnglish = (text: string) => {
    const regex = /^[^\uAC00-\uD7A3ㄱ-ㅎㅏ-ㅣ]*$/;
    return regex.test(text);
};

// YYYY-MM-DD 형식 검사 (월: 01~12, 일: 01~31)
export const isValidDateFormat = (context: string) => {
    const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    return regex.test(context);
};

// 양의 정수 
export const isPositiveInteger = (value: any) => {
    const num = Number(value);
    return Number.isInteger(num) && num > 0;
};
